import { useState } from 'react'

import type { ForceRerender } from './types'

const initialKey = Math.floor(Math.random() * 1_000_000)

export const useForceRerender = (): ForceRerender => {
  const [key, setKey] = useState(initialKey)

  const rerender = (): void => setKey(prevKey => prevKey + 1)

  return {
    key,
    rerender
  }
}
